import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-email\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.968 6H5.03l6.97 6.968L18.968 6zM3.75 6.839v9.944l4.972-4.972L3.75 6.839zm16.5 0-4.972 4.972 4.972 4.972V6.838v.001zm-6.034 6.033-2.215 2.217-2.219-2.217L4.653 18h14.694l-5.13-5.128zM2.25 19.5h19.5v-15H2.25v15z\" fill=\"#000018\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol